import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { PREMISE_AREA } from "tagTypes";

export const usePremiseAreaQuery = (query = {}, isFireSafety = false) =>
  useGetQuery({
    endpoint: isFireSafety
      ? "/firesafety-address/premise-area"
      : "/premise-area",
    query,
    tags: [PREMISE_AREA],
  });

export const useLazyPremiseAreaQuery = () => {
  const [getPremiseArea, data] = useLazyGetQuery();
  const premiseArea = async (query = {}) =>
    await getPremiseArea(
      {
        endpoint: "/premise-area",
        query,
        tags: [PREMISE_AREA],
      },
      true
    ).unwrap();
  return [premiseArea, data];
};

export const usePostPremiseAreaMutation = () => {
  const [premiseArea, data] = usePostMutation();
  const addPremiseArea = async (payload, query = {}) =>
    await premiseArea({
      endpoint: "/premise-area",
      query,
      payload: payload || {},
      toastMessage: "Premise area added successfully",
      tags: [PREMISE_AREA],
    }).unwrap();

  return [addPremiseArea, data];
};

export const usePutPremiseAreaMutation = () => {
  const [premiseArea, data] = usePutMutation();
  const updatePremiseArea = async (payload, id, query = {}) =>
    await premiseArea({
      endpoint: `/premise-area/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Premise area updated successfully",
      tags: [PREMISE_AREA],
    }).unwrap();
  return [updatePremiseArea, data];
};

export const useDeletePremiseAreaMutation = () => {
  const [premiseArea, data] = useDeleteMutation();
  const deletePremiseArea = async (id, query = {}) =>
    await premiseArea({
      endpoint: `/premise-area/${id}`,
      query,
      toastMessage: "Premise area deleted successully",
      tags: [PREMISE_AREA],
    }).unwrap();
  return [deletePremiseArea, data];
};
